import React from "react";
import TYPES from "./constants";

import RadioField from "./radioField/radioField.component";
import SimpleTextField from "./simpleTextField/simpleTextField.component";
import SelectField from "./selectField/selectField.component";
import SimpleTextAreaField from "./simpleTextAreaField/simpleTextAreaField.component";
import ImageFileField from "./imageFileField/imageFileField.component";
import FilesField from "./filesField/filesField.component";
import NumberField from "./numberField/numberField.component";
import RichTextField from "./richTextField/richTextField.component";
import JsonField from "./jsonField/jsonField.component";
import DateTimeField from "./datetimeField/datetimeField.component";
import CheckboxField from "./checkboxField/checkboxField.component";
import ColorField from "./colorField/colorField.component";
import BooleanRadioField from "./booleanRadioField/booleanRadioField.component";

const Field = ({ type, CustomComponent, ...props }) => {
  if (CustomComponent) return <CustomComponent type={type} {...props} />;
  switch (type) {
    case TYPES.CHECKBOX:
      return <CheckboxField {...props} />;
    case TYPES.COLOR:
      return <ColorField {...props} />;
    case TYPES.RADIO:
      return <RadioField {...props} />;
    case TYPES.BOOLEAN_RADIO:
      return <BooleanRadioField {...props} />;
    case TYPES.NUMBER:
      return <NumberField {...props} />;
    case TYPES.SIMPLE_TEXT:
      return <SimpleTextField {...props} />;
    case TYPES.SELECT:
      return <SelectField {...props} />;
    case TYPES.SIMPLE_TEXTAREA:
      return <SimpleTextAreaField {...props} />;
    case TYPES.TEXTAREA:
      return <RichTextField {...props} />;
    case TYPES.IMAGE_FILE:
      return <ImageFileField {...props} />;
    case TYPES.FILES:
      return <FilesField {...props} />;
    case TYPES.JSON:
      return <JsonField {...props} />;
    case TYPES.DATETIME:
      return <DateTimeField {...props} />;
    default:
      return <input type="text" {...props} />;
  }
};

export { TYPES };
export default Field;
